import { z } from 'zod';

const RSJFTypeSchema = z.any();
const RSJFTypeUiSchema = z.any();
const ReactElementSchema = z.any();
const LayoutSchema = z.any();
const LayoutConfigurationSchema = z.object({
  component: ReactElementSchema,
  x: z.number().nonnegative("x must be positive number"),
  y: z.number().nonnegative("y must be positive number"),
  width: z.number().positive("width must be positive number"),
  height: z.number().positive("height must be positive number"),
  movable: z.boolean().optional(),
  deletable: z.boolean().optional(),
  resizable: z.boolean().optional()
});
const WidgetSchema = z.object({
  name: z.string(),
  title: z.string().optional(),
  description: z.string().optional(),
  component: ReactElementSchema,
  width: z.number().positive("width must be positive number").optional(),
  height: z.number().positive("height must be positive number").optional(),
  minWidth: z.number().positive("minWidth must be positive number").optional(),
  maxWidth: z.number().positive("maxWidth must be positive number").optional(),
  minHeight: z.number().positive("minHeight must be positive number").optional(),
  maxHeight: z.number().positive("maxHeight must be positive number").optional(),
  settingsSchema: RSJFTypeSchema.optional(),
  uiSchema: RSJFTypeUiSchema.optional(),
  movable: z.boolean().optional(),
  deletable: z.boolean().optional(),
  resizable: z.boolean().optional()
});
const GridWidgetSchema = z.object({
  id: z.string(),
  layout: LayoutSchema,
  settings: z.record(z.string(), z.any()),
  movable: z.boolean().optional(),
  deletable: z.boolean().optional(),
  resizable: z.boolean().optional()
});
const CustomHomepageGridStateV1Schema = z.object({
  version: z.literal(1),
  pages: z.record(z.string(), z.array(GridWidgetSchema))
});

export { CustomHomepageGridStateV1Schema, LayoutConfigurationSchema, WidgetSchema };
//# sourceMappingURL=types.esm.js.map
